import { render, staticRenderFns } from "./AssignmentTable.vue?vue&type=template&id=31c7b8dc&scoped=true"
import script from "./AssignmentTable.vue?vue&type=script&lang=js"
export * from "./AssignmentTable.vue?vue&type=script&lang=js"
import style0 from "./AssignmentTable.vue?vue&type=style&index=0&id=31c7b8dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c7b8dc",
  null
  
)

export default component.exports